module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vshou3-097226c4a94a92b0cc4bda1ded5dc728.jpg";